/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { Button, Select } from "@chakra-ui/react";
import timezone from "../resources/timzone.json";
import { ProfileContext } from "../../../../store/ProfileProvider";

const SettingsTab: React.FC<{
  setSwalProps: any;
  userProfile: any;
  isFetching: boolean;
  triggerReload: any;
  setIsProcessing: React.Dispatch<React.SetStateAction<boolean>>;
  isProcessing: boolean;
}> = ({ setSwalProps, userProfile, isFetching, triggerReload, setIsProcessing, isProcessing }) => {
  const { setProfileTimeZone } = useContext(ProfileContext);
  const [settingsData, setSettingsData] = useState<any>(null);
  const userRole = localStorage.getItem("userRole");
  const username = localStorage.getItem("username");

  const handleInputChange = async (event: any) => {
    const { id, value } = event.target;
    setSettingsData({ ...settingsData, [id]: value });
  };

  const handleSubmit = async () => {
    setIsProcessing(true);
    try {
      const data = {
        userRole: userRole,
        sysUsername: username,
        ...settingsData,
      };

      await axios
        .post(`${process.env.REACT_APP_API_URL}/api/${userRole.toLowerCase()}/user/action/user-profile-update-settings`, data)
        .then(function (response) {
          setIsProcessing(false);
          if (response && response.data?.status === "ok") {
            setSwalProps({
              show: true,
              icon: "success",
              title: "Success",
              html: "Your settings has been update",
              showConfirmButton: true,
              didClose: async () => {
                setSwalProps({});
                setProfileTimeZone(settingsData.time_zone);
                localStorage.setItem("time_zone", settingsData.time_zone);
                triggerReload();
              },
            });
          } else {
            setIsProcessing(false);
            setSwalProps({
              show: true,
              icon: "error",
              title: "Oops!",
              html: "Something went wrong, please try again later.",
              showConfirmButton: true,
              didClose: () => {
                setSwalProps({});
                setIsProcessing(false);
              },
            });
          }
        })
        .catch(function (error) {
          setIsProcessing(false);
          setSwalProps({
            show: true,
            icon: "error",
            title: "Oops!",
            html: error.response.data.message,
            showConfirmButton: true,
            didClose: () => {
              setSwalProps({});
              setIsProcessing(false);
            },
          });
        });
    } catch (error: any) {
      setIsProcessing(false);
      setSwalProps({
        show: true,
        icon: "error",
        title: "Oops!",
        html: "Something went wrong, please try again later.",
        showConfirmButton: true,
        didClose: () => {
          setSwalProps({});
          setIsProcessing(false);
        },
      });
    }
  };

  useEffect(() => {
    if (userProfile !== null) {
      setSettingsData(userProfile);
    }
  }, [userProfile]); // eslint-disable-line

  const getTimezoneOffset = (tzName: string): string => {
    try {
      const now = new Date();
      const standardTime =
        new Intl.DateTimeFormat("en-US", {
          timeZone: tzName,
          timeZoneName: "longOffset",
        })
          .formatToParts(now)
          .find((part) => part.type === "timeZoneName")?.value || "";

      return standardTime.replace("GMT", "UTC");
    } catch (error) {
      console.error(`Invalid Timezone: ${tzName}`, error);
      return "UTC+00:00";
    }
  };

  const replaceUnderscoreWithSpace = (str: string) => {
    return str.replace(/_/g, " ");
  };

  return (
    <>
      <div className="p-7">
        {settingsData !== null ? (
          <>
            <div className="mb-5 text-sm text-navy-700 dark:text-white">
              <label className="text-sm font-medium text-navy-700 dark:text-white">
                Time Zone
              </label>
              <div className="flex items-start gap-3">
                <div className="w-full max-w-md">
                  <Select
                    disabled={isProcessing || !settingsData}
                    id="time_zone"
                    value={settingsData.time_zone}
                    onChange={handleInputChange}
                    className="custom-select relative w-full rounded-md border border-gray-300 bg-white py-2.5 pl-3 pr-10 shadow-sm focus:outline-none sm:text-sm"
                  >
                    {timezone &&
                      timezone.length > 0 &&
                      timezone.map((item: any) => {
                        const currentOffset = getTimezoneOffset(item.name);
                        return (
                          <option key={item.name} value={item.name}>
                            {currentOffset === "UTC"
                              ? "UTC+00:00"
                              : replaceUnderscoreWithSpace(item.name) +
                                " (" +
                                currentOffset +
                                ")"}
                          </option>
                        );
                      })}
                  </Select>
                </div>
                <Button
                  disabled={isProcessing}
                  onClick={() => handleSubmit()}
                  isLoading={isProcessing}
                  loadingText="Processing..."
                  className="btn btn-primary !py-2.5 !px-10"
                >
                  Save
                </Button>
              </div>
            </div>
          </>
        ) : (
          <>
            <div
              className="mb-3 mt-3 h-5 animate-pulse rounded-md bg-gray-200"
              style={{ animationDuration: "0.6s" }}
            ></div>
            <div
              className="mb-3 h-5 animate-pulse rounded-md bg-gray-200"
              style={{ animationDuration: "0.6s" }}
            ></div>
            <div
              className="mb-3 h-5 animate-pulse rounded-md bg-gray-200"
              style={{ animationDuration: "0.6s" }}
            ></div>
          </>
        )}
      </div>
    </>
  );
};

export default SettingsTab;
